import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Logo = () => {
  const [isHovering, setIsHovering] = useState(false);
  const [isPulsing, setPulsing] = useState(true);
  
  // Create a pulsing effect that runs continuously
  useEffect(() => {
    const interval = setInterval(() => {
      setPulsing(prev => !prev);
    }, 2000);
    
    return () => clearInterval(interval);
  }, []);
  
  return (
    <Link 
      to="/"
      className="flex items-center"
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <div className="relative">
        {/* Pulsing background circle - Updated with green background */}
        <div className={`absolute -inset-1 bg-ta-green/35 rounded-full transition-all duration-1000 ${isPulsing ? 'scale-110 opacity-100' : 'scale-100 opacity-70'}`}></div>
        
        {/* Logo image - Updated with new image URL and larger size */}
        <div className={`relative h-12 w-12 flex items-center justify-center transition-all duration-300 ${isHovering ? 'scale-110' : ''}`}>
          <img 
            src="https://imgur.com/1HmKGnQ.jpg" 
            alt="TravelCord Logo" 
            className="h-full w-full object-contain rounded-full"
          />
        </div>
      </div>
      <span className={`ml-2 text-lg font-bold ${isHovering ? 'text-ta-green-dark' : 'text-ta-green'} transition-colors duration-300`}>TravelCord</span>
    </Link>
  );
};

export default Logo;